type PermissionOnCheck = Record<string, boolean | undefined>;

interface PermissionVerbItem {
  type?: string;
  group?: string;
  resource?: string;
  relative?: {
    onCheck?: PermissionOnCheck;
  };
}

interface PermissionBlockItem {
  group?: string;
  resource?: string;
  list?: PermissionVerbItem[];
}

export interface PermissionRoleMapItem {
  group?: string;
  list?: PermissionBlockItem[];
}

export interface PermissionKey {
  /** API 组，如 'computing.stack.io' */
  group: string;
  /** 资源名称，如 'virtualmachines' */
  resource: string;
  /** 操作类型，如 'get', 'list', 'create', 'update', 'delete', 'patch' */
  type: string;
}

export function getAuthRelyOn(roleMap: PermissionRoleMapItem[], target: PermissionKey): PermissionOnCheck {
  for (const roleItem of roleMap || []) {
    for (const blockItem of roleItem.list || []) {
      for (const verbItem of blockItem.list || []) {
        const currentGroup = verbItem.group || blockItem.group || roleItem.group;
        const currentResource = verbItem.resource || blockItem.resource;
        const currentVerb = verbItem.type;
        if (currentGroup === target.group && currentResource === target.resource && currentVerb === target.type) {
          return verbItem.relative?.onCheck || {};
        }
      }
    }
  }
  return {};
}
